<template >
  <Teleport to="body">
    <Transition :name="transitionname">
      <div class="pfpopup pfpopup_alt" :class="{ 'pfpopup_alt2': alt }" @pointerdown="close" v-show="modelValue" @click.stop>
        <div class="pfpopup__content" :class="{ 'pfpopup__content_centered': centered, 'pfpopup__content_drop': drop }" ref="content" @pointerdown.stop>
          <CloseBtn v-if="closable" class="pfpopup__close" @click="close" :alt="alt" />
          <div v-else class="pfpopup__close" />
          <slot />
        </div>
      </div>
    </Transition>
  </Teleport>
</template>
<script>
import CloseBtn from './CloseBtn.vue'

export default {
  components: {
    CloseBtn
  },
  props: {
    modelValue: { type: Boolean },
    alt: { type: Boolean, default: false },
    centered: { type: Boolean, default: false },
    drop: { type: Boolean, default: false },
    closable: { type: Boolean, default: true },
    transitionname: { type: String, default: 'fade' }
  },
  methods: {
    close() {
      if (this.closable)
        this.$emit('update:modelValue', false)
    }
  },
}
</script>

<style lang="sass">
@keyframes drop
  0%
    transform: scale(1.2)
  100%  
    transform: none

.pfpopup
  position: fixed
  display: flex
  flex-direction: column
  align-items: center
  overflow-y: auto
  left: 0
  right: 0
  top: 0
  bottom: 0
  z-index: 1000000000
  background: rgba(20, 23, 54, 0.1)
  font-family: globalvars.$font6
  letter-spacing: globalvars.$onespacing
  .newred
    color: colors.$newred !important
  & &__title
    margin: 16px 0 48px
    font-weight: 500
    font-size: 24px
    line-height: 1.16
    color: colors.$bluefont
    text-align: center
    @include for-mob
      margin-bottom: 10px
  & &__text
    color: colors.$gray7
    font-size: 16px
    line-height: 26px    
    padding-bottom: 30px
    &_centered
      text-align: center

    @include for-mob
      padding-bottom: 20px
  & &__btn
    width: 328px
    max-width: 100%
    margin: 48px auto 32px
    &_closer
      margin: 16px auto 24px
  & &__content
    box-sizing: border-box
    width: 684px
    max-width: calc(100% - 20px)
    position: relative
    background: colors.$mainbg
    z-index: 1
    box-shadow: 0px 20px 40px rgba(34, 64, 92, 0.1)
    padding: 16px 32px
    margin: auto
    transform-origin: center center
    &_drop
      animation: drop .2s ease-out
    @include for-mob
      padding: 25px 20px

    &_centered
      min-height: 282px
      padding: 0
      display: flex
      flex-direction: column
      justify-content: center
      align-items: center
      text-align: center
      >*
        margin: 0
      .popup__text
        max-width: 500px
      .popup__text:last-child
        padding-bottom: 0
  & &__close
    position: absolute
    top: 20px
    right: 40px
    @include for-mob
      right: 20px
  &_alt
    background: transparentize(#343540, .75)
    & .pfpopup__content
      padding: 16px 32px 32px
      width: 668px
      box-shadow: none
      @include from(360px)
        padding: 16px
    & .pfpopup__close
      min-height: 16px
      position: static
      margin: 0 0 16px
      margin-left: auto
  &_alt2 &__content
    overflow: hidden
    padding: 16px 32px 32px
    width: 520px      
</style>